<template>
  <div class="home-container">
    <!-- 上面模块 -->
    <div class="home-top">
      <homeHead @intoView="intoView"></homeHead>
      <div class="nav">
        <ul class="nav-ul">
          <li>
            <p class="p-name">管楼宇，用楼域</p>
            <p class="p-notice">
              从装修工程、招商租赁、运营服务、资产运维到智能设备全面重塑楼宇管理，让楼宇资产运营中各个环节业务流程
              <span>统一化、规范化、数据化。</span>
            </p>
            <div class="input-div">
              <div class="unmer-div">
                <el-input
                  v-model.number="phoneNumber"
                  placeholder="请输入你的手机号"
                  maxlength="11"
                  style="height: 100%; width: 100%"
                ></el-input>
              </div>
              <div class="tips-div" @click="freeUse">免费试用</div>
            </div>
          </li>
          <li>
            <img
              src="../assets/imgs/play.png"
              alt="加载中"
              @click="showVideoLog"
            />
          </li>
        </ul>
        <!-- 新闻浮框 -->
        <ul class="news-ul">
          <li class="news-ul-li">
            <div
              class="news-ul-li-div"
              style="cursor: pointer"
              @click="
                open(
                  newsList[clickIdx].WIDGET_1703055388469[0] == '富文本展示'
                    ? 'router'
                    : 'url',
                  newsList[clickIdx].WIDGET_1703055388469[0] == '富文本展示'
                    ? newsList[clickIdx].WIDGET_1703055393097
                    : newsList[clickIdx].WIDGET_1646039167793
                )
              "
            >
              <template v-if="newsList[clickIdx]">
                <img
                  :src="newsList[clickIdx].WIDGET_1646039168862[0].url"
                  alt="图片加载"
                />
                <p class="title">
                  {{ newsList[clickIdx].WIDGET_1646039166020 }}
                </p>
                <p class="time">{{ newsList[clickIdx].CREATETIME }}</p>
              </template>
            </div>
          </li>
          <li class="news-ul-li">
            <div class="news-ul-li-div">
              <ul
                class="medule-news"
                v-infinite-scroll="loadNews"
                :infinite-scroll-disabled="
                  loading || pageVo.page == totalPages - 1
                "
              >
                <li
                  class="medule-news-li"
                  v-for="(vl, index) in newsList"
                  :key="index"
                  @mouseenter="selectNews(index)"
                >
                  <div
                    class="medule-box"
                    :class="clickIdx === index ? 'medule-box-click' : ''"
                  >
                    <div
                      class="medule-news-li-div-date"
                      :class="clickIdx === index ? 'isClick' : ''"
                    >
                      <div class="box">
                        <h2>{{ formatTime(vl.CREATETIME).day }}</h2>
                        <p>
                          {{ formatTime(vl.CREATETIME).year }}/{{
                            formatTime(vl.CREATETIME).month
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="medule-news-li-div-des">
                      <h3>
                        {{ vl.WIDGET_1646039166020 }}
                      </h3>
                      <span class="des-box">
                        {{ vl.WIDGET_1703055711043 }}
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li class="news-ul-li">
            <div class="news-ul-li-div">
              <div class="news-ul-li-div-containr">
                <h3 style="margin-top: -5px">公司热点</h3>
                <p>Company hotspot</p>
                <ul
                  class="hot-ul-box"
                  v-infinite-scroll="loadHots"
                  :infinite-scroll-disabled="
                    loadingHots || pageVoHots.page == totalPagesHots - 1
                  "
                >
                  <li
                    v-for="(item, idx) in hotsList"
                    :key="idx"
                    @click="
                      open(
                        item.WIDGET_1703055725992[0] == '富文本展示'
                          ? 'router'
                          : 'url',
                        item.WIDGET_1703055725992[0] == '富文本展示'
                          ? item.WIDGET_1703055880272
                          : item.WIDGET_1703054680135
                      )
                    "
                  >
                    {{ item.WIDGET_1703054678349 || "" }}
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 关于我们&商办痛点 -->
    <div class="shops-box">
      <!-- about us -->
      <div class="about-us-box">
        <div class="about-us-box-left">
          <img src="../assets/imgs/aboutus.png" alt="图片加载中" />
        </div>
        <div class="about-us-box-right">
          <div class="about-us-box-right-box">
            <p class="about-title">about us</p>
            <ul class="about-ul">
              <li>
                <div>
                  <img src="../assets/imgs/about_1.png" alt="图片加载中" />
                  <p>楼宇管理系统</p>
                </div>
              </li>
              <li>
                <div>
                  <img src="../assets/imgs/about_2.png" alt="图片加载中" />
                  <p>祖凭交易平台</p>
                </div>
              </li>
              <li>
                <div>
                  <img src="../assets/imgs/about_3.png" alt="图片加载中" />
                  <p>智能设备接入</p>
                </div>
              </li>
            </ul>
            <!-- des -->
            <div class="aboutus-description">
              <p>
                优动空间成立于2012年，迄今已在楼宇资产行业深耕细作八年。
                <span
                  >基于自身商办项目管理经验，搭建出楼宇资产管理系统——楼域
                  。</span
                >
              </p>
              <p>
                楼域由楼宇开拓、资产管理、工程施工、招商管理、物业运营、进销存管理、智能设备、财务管理、合同审批等核心应用组成，让楼宇管理标准化、流程化、格式化，有效统筹管理楼宇资产，助力楼宇经济腾飞式发展。
              </p>

              <div class="btn" @click="openUrl">
                查看更多 <img src="../assets/imgs/right-arrow.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- house diffcult -->
      <div class="hose-defficult-box">
        <div class="hose-defficult-box-content">
          <p class="defficult-title">商办资产管理痛点</p>
          <ul class="hose-defficult-ul">
            <li>
              <div
                v-for="(item, i) in difficultyList_left"
                :key="i"
                class="menn-div"
                :class="difficultIdx === item.flag ? 'isSelectDiv' : ''"
                @mouseenter="viewMenu(item)"
              >
                <p>{{ item.title }}</p>
                <p
                  v-for="(val, idxs) in item.des"
                  :key="idxs"
                  style="margin-bottom: 5px"
                >
                  {{ val }}
                </p>
              </div>
            </li>
            <li>
              <transition mode="out-in">
                <img :src="dificultyImag" alt="图片加载中" />
              </transition>
            </li>
            <li>
              <div
                v-for="(item, i) in difficultyList_right"
                :key="i"
                class="menn-div"
                :class="difficultIdx === item.flag ? 'isSelectDiv' : ''"
                @mouseenter="viewMenu(item)"
              >
                <p>{{ item.title }}</p>
                <p
                  v-for="(val, idxs) in item.des"
                  :key="idxs"
                  style="margin-bottom: 5px"
                >
                  {{ val }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 解决方案插图 （后续有功能添加或者修改的情况，再处理）-->
    <div class="programme-div">
      <img src="../assets/imgs/home_2.png" alt="加载中" />
    </div>
    <!--产品模型和高效模块 -->
    <div class="hoseModule_efficient">
      <!-- 模型模块 -->
      <div class="hoseModule_efficient-module">
        <p class="module-title">楼域产品模型</p>
        <div class="div-ul">
          <p
            v-for="(item, index) in moduleList"
            :key="index"
            :class="hosemoduleIdx === index ? 'moduleSelect' : ''"
            @mouseenter="viewModule(item, index)"
          >
            {{ item.title }}
          </p>
        </div>
        <img :src="moduleImg" alt="图片加载中" />
      </div>
      <!-- 高效 -->
      <div class="efficient-content">
        <p class="efficient-title">给典型客群带来的高效</p>
        <ul class="outside-ul">
          <li
            class="outside-ul-li"
            v-for="(item, idx) in efficientList"
            :key="idx"
            :class="efficientIdx === idx ? 'selectli' : ''"
            @mouseenter="viewEfficient(idx)"
          >
            <div class="outside-ul-li-content">
              <img
                :src="efficientIdx === idx ? item.white : item.darck"
                alt="图片加载中"
              />
              <p class="efficient-title-p">{{ item.title }}</p>
              <ul>
                <li
                  :class="efficientIdx === idx ? 'list-li_' : 'list-li'"
                  v-for="(vl, i) in item.list"
                  :key="i"
                >
                  {{ vl.des }}
                </li>
              </ul>
              <p>
                <span>0{{ idx + 1 }}</span
                >/0{{ efficientList.length }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 用楼宇模块 -->
    <div class="use-house">
      <div class="use-house-content">
        <p class="use-house-content-title">用楼域，管楼宇</p>
        <!-- 渲染部分 -->
        <ul class="use-house-content-ul">
          <li class="use-house-content-ul-li">
            <div class="use-house-content-ul-li-div">
              <span class="span-dom">功能对比</span>
              <span class="span-dom">无</span>
              <span class="span-dom">拥有部分</span>
              <span class="span-dom">用于全部</span>
              <!-- 功能列表 -->
              <div class="houseMenu-list">
                <div
                  :class="['houseMenu-list-box', 'houseMenu-list-box' + index]"
                  v-for="(item, index) in houseListData"
                  :key="index"
                  @click="reviewFn(index)"
                >
                  {{ item.title }}
                  <ul
                    @click.stop
                    :class="houseFnIdx === index ? 'showul' : 'unShowul'"
                  >
                    <li
                      v-for="(child, childidx) in item.children"
                      :key="childidx"
                      :style="{ color: child.color ? child.color : '#000000' }"
                    >
                      {{ child.title }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <!-- 数据遍历 -->
          <li
            class="use-house-content-ul-li"
            v-for="(item, i) in useHouseList"
            :key="i"
          >
            <div class="use-house-content-ul-li-div">
              <p>{{ item.title }}</p>
              <p>
                <span>￥</span>
                <span>{{ item.price }}</span>
                元/年
              </p>
              <p @click="intoView">立即购买</p>
              <!-- 功能列表 -->
              <div class="houseMenu-list_">
                <div
                  class="type-box"
                  v-for="(items, idx) in houseListData"
                  :key="idx"
                >
                  <div class="houseMenu-list-p">
                    <img
                      :src="
                        item.type === 'basics'
                          ? items.basicsImg
                          : item.type === 'senior'
                          ? items.seniorImg
                          : items.majorImg
                      "
                      alt="图片加载中"
                    />
                  </div>
                  <!-- 子集的内容 -->
                  <ul :class="houseFnIdx === idx ? 'showul' : 'unshowul'">
                    <li v-for="(vl, k) in items.children" :key="k">
                      <template v-if="item.type === 'basics'">
                        <div v-if="vl.isText">
                          {{ vl.basicsText }}
                        </div>
                        <div v-else>
                          <img :src="vl.basicsImg" alt="图片加载中" />
                        </div>
                      </template>
                      <template v-if="item.type === 'senior'">
                        <div v-if="vl.isText">
                          {{ vl.seniorText }}
                        </div>
                        <div v-else>
                          <img :src="vl.seniorImg" alt="图片加载中" />
                        </div>
                      </template>
                      <template v-if="item.type === 'major'">
                        <div v-if="vl.isText">
                          {{ vl.majorText }}
                        </div>
                        <div v-else>
                          <img :src="vl.majorImg" alt="图片加载中" />
                        </div>
                      </template>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 联系方式 -->
    <div class="conection-message">
      <div class="conection-message-box">
        <div class="conection-message-box-left">
          <p>留下您的联系方式，获得专属顾问</p>
          <p>或致电我们，让我们为您服务</p>
          <p>服务时间: 周一至周五 9:30-17:30</p>
          <img src="../assets/imgs/qr.png" alt="图片加载中" ref="imgRef" />
          <span>扫码了解更多</span>
        </div>
        <div class="conection-message-box-right">
          <el-form :model="messageForm" :rules="rulesData" ref="ruleFormRef">
            <el-form-item prop="complanyNmame">
              <el-input
                v-model="messageForm.complanyNmame"
                placeholder="请输入公司的名字"
              ></el-input>
            </el-form-item>
            <el-form-item prop="userName">
              <el-input
                v-model="messageForm.userName"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item prop="phoneMenber">
              <el-input
                v-model.number="messageForm.phoneMenber"
                maxlength="11"
                placeholder="请输入手机号"
                type="tel"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <ul class="code-ul">
                <li>
                  <el-input
                    v-model="messageForm.code"
                    placeholder="请输入验证码"
                    maxlength="6"
                  ></el-input>
                </li>
                <li>
                  <el-button
                    type="primary"
                    :disabled="!messageForm.phoneMenber"
                    @click="getPhoneCode"
                  >
                    {{ submitFlag ? noClick : "发送验证码" }}
                  </el-button>
                </li>
              </ul>
            </el-form-item>
            <el-form-item prop="content">
              <el-input
                v-model="messageForm.content"
                type="textarea"
                rows="5"
                placeholder="输入留言"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div style="height: 59px; width: 163px">
                <el-button type="primary" @click="submit">提交</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="site-footer">
      <div class="site-footer-body">
        <ul>
          <li>
            <img src="../assets/imgs/sitefooter.png" alt="图片加载中" />
          </li>
          <li class="email-li">E-MAIL</li>
          <li class="tel-li">TEL</li>
          <li class="address-li">ADDRESS</li>
        </ul>
        <p class="tips">
          @ 2021 楼宇 | 京ICP备20032023号 | 版权所有 北京优动空间科技有限公司 |
          LOUYY.CO
        </p>
      </div>
    </div>
    <!-- video -->
    <el-dialog :fullscreen="true" v-model="show">
      <div class="video-div">
        <video src="movie.ogg" controls="controls">
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, ref, onMounted } from "vue";
import homeHead from "@/components/HomeHead";
import { ruleObj } from "@/utils/formRules";
import {
  userLogin,
  getFormControl,
  addComment,
  getCode,
  getHomeNewsList,
  getHomeHotsList,
} from "@/api/home";
import { ElMessage } from "element-plus";
import {
  news_left,
  nuews_right,
  houseModule,
  efficient,
  typeList,
  houseList,
} from "@/utils/mockData";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "Home",
  components: {
    homeHead,
  },
  setup() {
    const data = reactive({
      phoneMenber: "",
      clickIdx: 0, // 点击新闻的高亮
      difficultyList_left: news_left,
      difficultyList_right: nuews_right,
      dificultyImag: news_left[0].img,
      difficultIdx: 0, // 招租点击的问题
      moduleList: houseModule,
      moduleImg: houseModule[0].img,
      hosemoduleIdx: 0,
      efficientList: efficient,
      efficientIdx: 0,
      useHouseList: typeList,
      houseListData: houseList,
      houseFnIdx: -1, // 展开收缩（没做动画）
      loading: false,
      loadingHots: false,
      pageVo: {
        page: -1,
        size: 10,
      },
      pageVoHots: {
        page: -1,
        size: 10,
      },
      totalPages: 1,
      totalPagesHots: 1,
      newsList: [],
      hotsList: [],
    });
    // 表单的值
    const formData = reactive({
      controlList: [],
      phoneNumber: "",
      submitFlag: false,
      noClick: "",
      trimer: null,
      m: 80,
      messageForm: {
        complanyNmame: "",
        userName: "",
        phoneMenber: "",
        code: "",
        content: "",
      },
    });

    // video模块
    const videoData = reactive({
      show: false,
    });
    // 系统ID配置
    const idConfig = reactive({
      appId: "C9176FF08DB443AF8C7E3A53E62CBC90",
      formId: "E99BEAD4B95D45F98F944529A51B54EB",
      systemId: "91F0FD9EBBB84E82AE0223C35B7ADF0B",
    });
    // 规则
    const rulesData = ref({ ...ruleObj });
    // 确定滚动到节点位置
    const ruleFormRef = ref(null);
    const imgRef = ref(null);
    const selectNews = (i) => {
      data.clickIdx = i;
    };
    const viewMenu = (item) => {
      const { flag, img } = item;
      data.difficultIdx = flag;
      data.dificultyImag = img;
    };

    const openUrl = () => {
      router.push({
        path: "/displayPage",
      });
    };

    const viewModule = (item, idx) => {
      const { img } = item;
      data.hosemoduleIdx = idx;
      data.moduleImg = img;
    };
    const viewEfficient = (idx) => {
      data.efficientIdx = idx;
    };
    const reviewFn = (idx) => {
      if (data.houseFnIdx === idx) {
        // 重复点击
        data.houseFnIdx = -1;
      } else {
        data.houseFnIdx = idx;
      }
    };
    const intoView = () => {
      imgRef.value.scrollIntoView();
    };
    const showVideoLog = () => {
      // videoData.show = true
      // TODO 暂时没有视屏资源
      ElMessage({
        message: "视频制作中，请耐心等待!!!",
        type: "warning",
      });
    };
    const freeUse = () => {
      if (!formData.phoneNumber) {
        ElMessage({
          message: "请填写手机号",
          type: "warning",
        });
      } else {
        imgRef.value.scrollIntoView();
        formData.messageForm.phoneMenber = formData.phoneNumber;
      }
    };
    const getPhoneCode = () => {
      if (formData.submitFlag) return;
      const p = {
        userPhone: formData.messageForm.phoneMenber,
        verificationCodeType: 8,
        systemId: idConfig.systemId,
      };
      getCode(p)
        .then((res) => {
          if (res.success) {
            ElMessage({
              message: "验证码已经发送，请注意查收",
              type: "success",
            });
            formData.submitFlag = true;
            formData.trimer = setInterval(() => {
              if (formData.m <= 1) {
                formData.submitFlag = false;
                formData.m = 80;
                clearInterval(formData.trimer);
              }
              formData.noClick = `请在${formData.m}s重新发送`;
              formData.m--;
            }, 1000);
          } else {
            ElMessage({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch(() => {
          formData.submitFlag = false;
        });
    };
    const submit = () => {
      ruleFormRef.value.validate((valid) => {
        if (valid) {
          const { complanyNmame, userName, phoneMenber, code, content } =
            formData.messageForm;
          const objParam = formData.controlList.reduce((cur, item) => {
            if (item.name === "公司名称") {
              cur[item.model] = complanyNmame;
            } else if (item.name === "姓名") {
              cur[item.model] = userName;
            } else if (item.name === "手机") {
              cur[item.model] = phoneMenber;
              cur[`${item.model}_code`] = code;
            } else if (item.name === "留言") {
              cur[item.model] = content;
            }
            return cur;
          }, {});
          const pars = {
            formData: objParam,
          };
          addComment(pars, idConfig.systemId, idConfig.appId, idConfig.formId)
            .then((res) => {
              if (res.success) {
                ElMessage({
                  message: "感谢你的留言",
                  type: "success",
                });
                formData.messageForm.content = "";
                ruleFormRef.value.resetFields();
                clearInterval(formData.trimer);
              } else {
                ElMessage({
                  message: "提交失败",
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log("err提交失败======>", err);
            });
        } else {
          return false;
        }
      });
    };
    const login = () => {
      if (localStorage.getItem("token")) return;

      console.log("匿名登陆");
      const par = {
        grant_type: "password",
        login_type: "ANONYMOUS_USER",
        username: "test",
        password: "test",
        appId: idConfig.appId,
        formId: idConfig.formId,
        systemId: idConfig.systemId,
      };
      userLogin(par)
        .then((res) => {
          const { accessToken } = res.data;
          localStorage.setItem("token", accessToken);
          // window.location.reload()
        })
        .catch((err) => {
          console.log("err========>", err);
        });
    };
    const getControl = () => {
      const paramas = {
        appId: idConfig.appId,
        formId: idConfig.formId,
        systemId: idConfig.systemId,
      };
      getFormControl(paramas)
        .then((res) => {
          const { data } = res;
          const controlName = ["公司名称", "姓名", "手机", "留言"];
          const controlist = data.reduce((cur, item) => {
            if (controlName.includes(item.controlsName)) {
              let obj = {};
              obj["name"] = item.controlsName;
              obj["model"] = item.controlsModel;
              cur.push(obj);
            }
            return cur;
          }, []);
          formData.controlList = controlist;
        })
        .catch((err) => {
          console.log("err======", err);
        });
    };
    // 新闻
    const getNews = () => {
      data.loading = true;
      const page = {
        size: data.pageVo.size,
        page: data.pageVo.page,
        scope: "ALL",
        childTable: false,
        sort: [{ CREATETIME: "DESC" }],
        filter: [],
      };
      getHomeNewsList(page)
        .then((res) => {
          console.log(res);
          data.totalPages = res.data.totalPages;
          data.newsList = [...data.newsList, ...res.data.content];
          data.loading = false;
        })
        .catch((err) => {
          console.log(err);
          data.loading = false;
        });
    };
    const loadNews = () => {
      if (data.pageVo.page < data.totalPages - 1) {
        data.pageVo.page++;
        getNews();
      }
    };
    const formatTime = (time) => {
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return { year, month, day };
    };
    // 热点
    const getHots = () => {
      data.loadingHots = true;
      const page = {
        size: data.pageVoHots.size,
        page: data.pageVoHots.page,
        scope: "ALL",
        childTable: false,
        sort: [{ CREATETIME: "DESC" }],
        filter: [],
      };
      getHomeHotsList(page)
        .then((res) => {
          console.log(res);
          data.totalPagesHots = res.data.totalPages;
          data.hotsList = [...data.hotsList, ...res.data.content];
          data.loadingHots = false;
        })
        .catch((err) => {
          console.log(err);
          data.loadingHots = false;
        });
    };
    const loadHots = () => {
      if (data.pageVoHots.page < data.totalPagesHots - 1) {
        console.log("在加载");
        data.pageVoHots.page++;
        getHots();
      }
    };
    // 处理打开方式
    const router = useRouter();
    const open = (type, content) => {
      if (type == "url") {
        window.open(content);
      }
      if (type == "router") {
        const resolved = router.resolve({
          name: "Info",
          query: { content: content },
        });
        window.open(resolved.href, "_blank");
      }
    };

    onMounted(() => {
      login();
      getControl();
      data.newsList = [];
    });
    return {
      ...toRefs(data),
      selectNews, // 点击查看新闻
      viewMenu, // 查看商办痛点
      viewModule, // 查看楼宇模型
      openUrl,
      viewEfficient, // 查看高效模块
      reviewFn, // 查看菜单栏（没做动画）
      intoView, // 滚动到底部查看
      ...toRefs(formData),
      rulesData,
      imgRef,
      ruleFormRef,
      submit,
      ...toRefs(videoData),
      ...toRefs(idConfig),
      showVideoLog,
      freeUse,
      login,
      getControl,
      getPhoneCode,
      getNews,
      loadNews,
      formatTime,
      getHots,
      loadHots,
      open,
    };
  },
});
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.home-container {
  background: #ffffff;
}
@mixin nav-style($height) {
  height: $height;
  background: url(../assets/imgs/home_1.png) center;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
@mixin img-style($px) {
  height: $px;
  width: $px;
  display: block;
  cursor: pointer;
}
.nav {
  @include nav-style(730px);
  ul.nav-ul {
    width: 80%;
    height: 400px;
    display: flex;
    li {
      height: inherit;
      width: 50%;
    }
    li:first-child {
      p.p-name {
        color: #1c79e5;
        font-size: 62px;
        font-weight: bold;
      }
      p.p-name::after {
        content: "";
        display: block;
        background: #1c79e5;
        margin-top: 40px;
        height: 11px;
        width: 98px;
        border-radius: 6px;
      }
      p.p-notice {
        margin-top: 32px;
        font-size: 25px;
        font-weight: 500;
        span {
          color: #1c79e5;
        }
      }
      div.input-div {
        width: 552px;
        margin-top: 46px;
        display: flex;
        .unmer-div,
        .tips-div {
          height: 57px;
        }
        /** /deep/ >>> 在scss中废弃 改用以下用法 */
        div.unmer-div {
          width: 357px;
          :deep(.el-input__inner) {
            height: inherit;
            font-size: 26px;
            font-weight: 400;
            outline: none;
            border-radius: 4px 0 0 4px;
          }
        }
        div.tips-div {
          width: calc(100% - 357px);
          color: #ffffff;
          font-size: 30px;
          font-weight: bold;
          line-height: 57px;
          text-align: center;
          background: #1c79e5;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          cursor: pointer;
        }
        div.tips-div {
          background: #409eff;
        }
      }
    }
    li:last-child {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        @include img-style(144px);
      }
    }
  }
  ul.news-ul {
    position: absolute;
    height: 350px;
    width: 80%;
    left: 10%;
    bottom: -300px;
    display: flex;
    li.news-ul-li {
      width: 33%;
      height: inherit;
      box-sizing: border-box;
      padding: 10px;
      background-clip: content-box;
      div.news-ul-li-div {
        height: inherit;
        box-shadow: -2px 4px 5px 0px rgba(0, 0, 0, 0.16);
        border-radius: 10px;
        background: #fbfbfb;
        // padding-top: 26px;
        padding: 26px 0;
      }
      .news-ul-li-div:nth-child(1) {
        img {
          display: block;
          width: 90%;
          height: 258px;
          margin: 0 auto;
        }
        .title,
        .time {
          width: 90%;
          margin: 0 auto;
          margin-top: 10px;
        }
        .title {
          font-size: 18px;
          font-weight: bold;
          color: #515151;
        }
        .time {
          font-size: 14px;
          font-weight: 500;
          color: #515151;
        }
      }
      .news-ul-li-div-containr {
        width: 90%;
        margin: 0 auto;
        h3 {
          color: #008dff;
          font-weight: bold;
          // text-align: center;
          font-size: 24px;
        }
        p {
          line-height: 30px;
          font-weight: 500;
          color: #898787;
          font-size: 12px;
          // text-align: center;
        }
        p::after {
          content: "";
          display: block;
          height: 2px;
          background: #dcdcdc;
        }
        .hot-ul-box {
          height: 270px;
          overflow-y: scroll;
          margin-top: 20px;
          li {
            // width: inherit;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            font-weight: 500;
            line-height: 40px;
            color: #515151;
            cursor: pointer;
          }
        }
      }
      .medule-news {
        height: inherit;
        overflow-y: scroll;
        .medule-news-li {
          height: 33.3%;
          cursor: pointer;
          .medule-box {
            display: flex;
            height: 100%;
            .medule-news-li-div-date {
              width: 100px;
              display: flex;
              justify-content: center;
              align-items: center;
              div {
                height: 40px;
                width: inherit;
                text-align: center;
              }
            }
            .isClick {
              background: url(../assets/imgs/isClick.png) center;
              background-size: cover;
              color: #ffffff;
            }
            .medule-news-li-div-des {
              width: calc(100% - 130px);
              padding-top: 12px;
              overflow: hidden;
              margin-left: 10px;
              display: flex;
              flex-direction: column;
              h3 {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .des-box {
                height: 40px;
                font-size: 14px;
                font-weight: 500;
                color: #515151;
                word-wrap: break-word;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-word;
              }
            }
          }
          .medule-box-click {
            background: #edf3f9;
          }
        }
      }
    }
  }
}
@mixin shops-box-style($height) {
  margin-top: $height;
}
@mixin about-us-box-style($height, $width) {
  display: flex;
  height: $height;
  width: $width;
  margin: 0 auto;
  background: url(../assets/imgs/about.png) no-repeat bottom;
}
@mixin difficut($width) {
  width: $width;
  margin: 0 auto;
}
.shops-box {
  @include shops-box-style(420px);
  .about-us-box {
    @include about-us-box-style(800px, 80%);
    .about-us-box-right {
      width: 40%;
      height: inherit;
      &-box {
        height: inherit;
        width: 80%;
        margin: 0 auto;
        position: relative;
        padding-top: 73px;
        .about-title {
          font-size: 37px;
          font-weight: bold;
          font-family: PingFang SC;
          color: #007eff;
        }
        .about-title::after {
          display: block;
          content: "关于我们";
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #515151;
          margin-top: 10px;
        }
        .about-ul {
          position: absolute;
          top: 205px;
          left: -27%;
          width: 120%;
          height: 161px;
          background: #3699ff;
          display: flex;
          li {
            width: 33.3%;
            display: flex;
            align-items: center;
            justify-content: center;
            div {
              width: 100px;
              color: #ffffff;
              font-size: 15px;
              font-weight: 800;
              text-align: center;
              img {
                display: block;
                height: 38px;
                width: 39px;
                margin: 0 auto;
              }
              p {
                margin-top: 17px;
              }
            }
          }
          li:nth-child(1) {
            justify-content: flex-end !important;
          }
        }
        .aboutus-description {
          font-size: 18px;
          font-weight: 500;
          margin-top: 260px;
          p {
            margin-bottom: 35px;
            span {
              color: #007eff;
            }
          }
        }
      }
    }
    .about-us-box-left {
      width: calc(100% - 40%);
      height: inherit;
      img {
        display: block;
        height: 100%;
        width: 100%;
      }
    }
  }
  // 管理痛点
  .hose-defficult-box {
    margin-top: 108px;
    &-content {
      @include difficut(80%);
      .defficult-title {
        text-align: center;
        font-size: 48px;
        font-weight: 800;
        color: #1c79e5;
      }
      .defficult-title::after {
        display: block;
        content: "楼宇数据信息管理无法全链路打通，资产真实经营情况难以分析";
        font-size: 26px;
        font-family: PingFang SC;
        margin-top: 15px;
        font-weight: 500;
        color: #515151;
      }
      .hose-defficult-ul {
        height: 500px;
        display: flex;
        margin-top: 30px;
        justify-content: space-between;
        li {
          // width: 33.3%;
          box-sizing: border-box;
          padding: 10px;
          background-clip: content-box;
          div.menn-div {
            height: 33.3%;
            box-sizing: border-box;
            padding: 10px 20px;
            background-clip: content-box;
            cursor: pointer;
            border-radius: 5px;
            p:first-child {
              font-size: 22px;
              font-weight: 800;
              margin-bottom: 16px;
            }
            p.last-child {
              font-size: 16px;
              font-weight: 500;
            }
          }
          div.isSelectDiv {
            background: #3699ff;
            color: #ffffff;
          }
        }
        li:nth-child(1) {
          width: 25%;
        }
        li:nth-child(3) {
          width: 25%;
        }
        li:nth-child(2) {
          width: 40%;
          img {
            display: block;
            height: 100%;
            width: 100%;
          }
        }
      }
    }
  }
}
// 插图
div.programme-div {
  height: 900px;
  margin: 60px 0 60px 0;
  img {
    display: block;
    height: 100%;
    width: 100%;
  }
}
@mixin module-style($width) {
  width: $width;
  margin: 0 auto;
}
// 模块和高效【模块】
div.hoseModule_efficient-module {
  @include module-style(80%);
  p.module-title {
    text-align: center;
    font-size: 48px;
    font-weight: 800;
    color: #1c79e5;
    margin-bottom: 27px;
  }
  p.module-title::after {
    content: "用科技重塑楼宇资产管理，通过数据智能驱动存量资产价值新增长。";
    display: block;
    font-weight: 500;
    font-size: 22px;
    color: #515151;
    margin-top: 27px;
  }
  div.div-ul {
    position: relative;
    display: flex;
    p {
      width: 10%;
      text-align: center;
      cursor: pointer;
      font-size: 24px;
      font-weight: 500;
      line-height: 50px;
      color: #515151;
    }
    p.moduleSelect {
      color: #007eff;
      border-bottom: 6px solid #007eff;
    }
  }
  div.div-ul ::after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    background: #bfbfbf;
    height: 1px;
    border-radius: 2px;
  }
  img {
    display: block;
    width: 100%;
    height: 500px;
    margin-top: 30px;
  }
}
// 高效模块
div.efficient-content {
  @include module-style(80%);
  margin-top: 40px;
  p.efficient-title {
    text-align: center;
    font-size: 48px;
    font-weight: 800;
    color: #1c79e5;
    margin-bottom: 27px;
  }
  .outside-ul {
    display: flex;
    background: url("../assets/imgs/house_h.png") no-repeat bottom;
    // background-position-y: 346px;
    background-size: 100%;
    li.outside-ul-li {
      width: 20%;
      // box-sizing: border-box;
      // padding: 10px 10px;
      // background-clip: content-box;
      div.outside-ul-li-content {
        height: 580px;
        padding: 20px;
        position: relative;
        overflow: hidden;
        img {
          display: block;
        }
        p.efficient-title-p {
          color: #1c79e5;
          font-size: 36px;
          font-weight: 800;
          margin: 33px 0;
        }
        p:last-child {
          position: absolute;
          left: 15px;
          bottom: 15px;
          span {
            font-size: 24px;
            font-weight: 800;
          }
        }
      }
      ul {
        height: 360px;
        li.list-li {
          line-height: 30px;
          position: relative;
        }
        li.list-li::before {
          position: absolute;
          display: block;
          content: "";
          height: 10px;
          width: 10px;
          background: #1c79e5;
          left: -14px;
          top: 10px;
        }
        li.list-li_ {
          line-height: 30px;
          position: relative;
        }
        li.list-li_::before {
          position: absolute;
          display: block;
          content: "";
          height: 10px;
          width: 10px;
          background: #ffffff;
          left: -14px;
          top: 10px;
        }
      }
    }
    .selectli {
      background: #1c79e5;
      p.efficient-title-p {
        color: #ffffff !important;
      }
      div.outside-ul-li-content {
        color: #ffffff;
      }
      p:last-child {
        span {
          color: #ffffff;
        }
      }
    }
  }
}
// 用楼宇模块
@mixin use-house-style($width) {
  width: $width;
}
div.use-house {
  display: flex;
  justify-content: center;
  margin-top: 130px;
  &-content {
    @include use-house-style(80%);
    p.use-house-content-title {
      text-align: center;
      font-weight: 800;
      color: #1c79e5;
      font-size: 48px;
    }
    p.use-house-content-title::after {
      content: "楼域力求通过科学的特征组合，让不同需求的用户感到物超所值。";
      display: block;
      font-size: 26px;
      font-weight: 500;
      color: #515151;
      line-height: 72px;
    }
    .use-house-content-ul {
      display: flex;
      margin-top: 80px;
      .use-house-content-ul-li {
        width: 25%;
        box-sizing: border-box;
        padding: 10px;
        background-clip: content-box;
        display: flex;
        justify-content: center;
        position: relative;
      }
      .use-house-content-ul-li > div {
        width: 100%;
        padding: 30px;
        p {
          text-align: center;
          margin-bottom: 40px;
        }
        p:nth-child(1) {
          color: #515151;
          font-size: 52px;
          font-weight: bold;
        }
        p:nth-child(2) {
          font-size: 24px;
          white-space: nowrap;
          span {
            color: #3a98fb;
          }
          span:last-child {
            font-size: 36px;
            font-weight: bold;
          }
        }
        p:nth-child(3) {
          color: #ffffff;
          height: 66px;
          background: #6caffe;
          border-radius: 10px;
          font-size: 36px;
          font-weight: 500;
          line-height: 66px;
          cursor: pointer;
        }
      }
      .use-house-content-ul-li-div:nth-child(1) {
        span.span-dom {
          display: block;
          font-size: 24px;
          color: #515151;
          font-weight: 400;
          margin-bottom: 10px;
          position: relative;
        }
        span.span-dom:nth-child(1) {
          font-size: 60px;
          font-weight: 800;
          color: hsl(211, 100%, 50%);
          margin-top: -50px;
          white-space: nowrap;
        }
        span.span-dom:nth-child(1)::after {
          content: "Function comparison";
          display: block;
          font-size: 20px;
          color: #8e8e8e;
          margin-top: 25px;
        }
        span.span-dom:nth-child(2),
        span.span-dom:nth-child(3),
        span.span-dom:nth-child(4) {
          padding-left: 25px;
        }
        span.span-dom:nth-child(2)::before {
          content: "";
          width: 14px;
          height: 4px;
          background: url("../assets/imgs/null.png");
          display: block;
          position: absolute;
          left: 0;
          top: 50%;
        }
        span.span-dom:nth-child(3)::before {
          content: "";
          width: 23px;
          height: 19px;
          border: 1px dashed #000000;
          background: url("../assets/imgs/some.png");
          display: block;
          position: absolute;
          left: -7px;
          top: 50%;
          margin-top: -10px;
        }
        span.span-dom:nth-child(4)::before {
          content: "";
          width: 23px;
          height: 19px;
          border: 1px dashed #000000;
          background: url("../assets/imgs/all.png");
          display: block;
          position: absolute;
          left: -7px;
          top: 50%;
          margin-top: -10px;
        }
        div.houseMenu-list {
          margin-top: 92px;
          &-box {
            margin-bottom: 20px;
            font-size: 23px;
            font-weight: 600;
            position: relative;
            padding-left: 26px;
            cursor: pointer;
            li {
              margin-top: 20px;
              font-weight: 400;
            }
          }
          .before-style {
            content: "";
            position: absolute;
            left: -9px;
            top: 0;
            height: 32px;
            width: 32px;
            background-size: 100% 100%;
          }
          .houseMenu-list-box0::before {
            @extend .before-style;
            background: url("../assets/imgs/f1.png") no-repeat;
          }
          .houseMenu-list-box1::before {
            @extend .before-style;
            background: url("../assets/imgs/f2.png") no-repeat;
          }
          .houseMenu-list-box2::before {
            @extend .before-style;
            background: url("../assets/imgs/f3.png") no-repeat;
          }
          .houseMenu-list-box3::before {
            @extend .before-style;
            background: url("../assets/imgs/f4.png") no-repeat;
          }
          .houseMenu-list-box4::before {
            @extend .before-style;
            background: url("../assets/imgs/f5.png") no-repeat;
          }
          .unShowul {
            display: none;
          }
          .showul {
            display: block;
          }
        }
      }
      .other-before-style {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -62px;
        width: 124px;
        height: 18px;
        border-radius: 9px;
      }
      @mixin bgColor($color) {
        background: $color;
      }
      .use-house-content-ul-li:nth-child(2) {
        .use-house-content-ul-li-div {
          border: 2px solid #6caffe;
          border-radius: 10px;
        }
      }
      .use-house-content-ul-li:nth-child(2)::before {
        @extend .other-before-style;
        @include bgColor(#6caffe);
      }
      .use-house-content-ul-li:nth-child(3) {
        .use-house-content-ul-li-div {
          border: 2px solid #6caffe;
          border-radius: 10px;
        }
      }
      .use-house-content-ul-li:nth-child(3)::before {
        @extend .other-before-style;
        @include bgColor(#6caffe);
      }
      .use-house-content-ul-li:nth-child(4) {
        .use-house-content-ul-li-div {
          border: 2px solid #2e2bca;
          border-radius: 10px;
          p:nth-child(2) {
            span {
              color: #2e2bca;
            }
          }
          p:nth-child(3) {
            background: #2e2bca;
          }
        }
      }
      .use-house-content-ul-li:nth-child(4)::before {
        @extend .other-before-style;
        @include bgColor(#2e2bca);
      }
      // 修饰里面的内容
      .use-house-content-ul-li:nth-child(2),
      .use-house-content-ul-li:nth-child(3),
      .use-house-content-ul-li:nth-child(4) {
        .houseMenu-list-p {
          font-size: 24px;
          font-weight: 800;
          text-align: center;
          margin-bottom: 20px;
        }
        div.type-box {
          .unshowul {
            display: none;
          }
          .showul {
            display: block;
          }
          li {
            font-size: 24px;
            font-weight: 400;
            text-align: center;
            margin-bottom: 20px;
          }
          li:nth-child(odd) {
            background: rgba(139, 191, 252, 0.1);
          }
        }
      }
    }
  }
}
// 联系方式
@mixin conection-message-style($bgColor, $margin, $height) {
  background: $bgColor;
  height: $height;
  margin-top: $margin;
  padding-top: $margin;
  display: flex;
  justify-content: center;
}
@mixin message-box-style($width) {
  width: $width;
  height: inherit;
  display: flex;
}
.conection-message {
  @include conection-message-style(#f9fbfe, 75px, 580px);
  &-box {
    > div {
      height: inherit;
      width: 50%;
    }
    @include message-box-style(80%);
    .conection-message-box-left {
      p {
        margin-bottom: 38px;
      }
      p:nth-child(1) {
        font-size: 36px;
        font-weight: bold;
        color: #007cff;
      }
      p:nth-child(2) {
        font-size: 24px;
        font-weight: 500;
      }
      p:nth-child(2)::after {
        content: "010-6297-0616";
        display: block;
        font-size: 36px;
        font-weight: bold;
      }
      p:nth-child(3) {
        font-size: 24px;
        font-weight: 500;
      }
      img {
        display: block;
        height: 150px;
        width: 150px;
      }
      span {
        width: 197px;
        display: block;
        // text-align: center;
        padding-left: 10px;
        font-weight: 400;
        color: #515151;
        font-size: 22px;
        margin-top: 23px;
      }
    }
    .conection-message-box-right {
      .code-ul {
        width: 100%;
        display: flex;
        li {
          height: 59px;
        }
        li:last-child {
          width: 180px;
          margin-left: auto;
        }
        li:first-child {
          width: calc(100% - 200px);
        }
      }
      :deep(.el-input__inner) {
        height: 59px;
        font-size: 20px;
      }
      :deep(.el-button) {
        height: 100%;
        width: 100%;
        font-size: 20px;
      }
      :deep(.el-textarea__inner) {
        font-size: 20px;
      }
    }
  }
}
// 页脚
@mixin site-footer-style {
  display: flex;
  justify-content: center;
  background: #2f3034;
  color: #ffffff;
  padding-bottom: 25px;
}
div.site-footer {
  @include site-footer-style;
  &-body {
    height: inherit;
    width: 80%;
    padding-top: 30px;
    ul {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      li {
        position: relative;
        padding-left: 30px;
        img {
          display: block;
        }
      }
      @mixin brfore-style {
        content: "";
        height: 20px;
        width: 25px;
        position: absolute;
        top: 0;
        left: 0;
        position: absolute;
      }
      @mixin after-style {
        display: block;
        margin-left: -30px;
        margin-top: 16px;
      }
      li.email-li::after {
        content: "电子邮箱 info@louyy.com";
        @include after-style;
      }
      li.email-li::before {
        @include brfore-style;
        background: url("../assets/imgs/email.png") no-repeat;
      }
      li.tel-li::after {
        content: "联系电话 010-62970616";
        @include after-style;
      }
      li.tel-li::before {
        @include brfore-style;
        background: url("../assets/imgs/phone.png") no-repeat;
      }
      li.address-li::after {
        content: "通讯地址 北京市海淀区中关村软件园一期2A号楼";
        @include after-style;
      }
      li.address-li::before {
        @include brfore-style;
        background: url("../assets/imgs/address.png") no-repeat;
      }
    }
    .tips {
      text-align: center;
      margin-top: 30px;
    }
    .tips::before {
      content: "";
      display: block;
      height: 1px;
      border: 1px solid #e5e5e5;
      background: #e5e5e5;
      margin-bottom: 25px;
      background: #e5e5e5;
    }
  }
}
:deep(.el-dialog.is-fullscreen) {
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
:deep(.el-dialog__body) {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}
:deep(.el-dialog__header) {
  padding: 0;
}
.video-div {
  height: 90%;
  width: 90%;
  video {
    height: 100%;
    width: 100%;
  }
}

.btn {
  margin-top: 52px;
  height: 50px;
  cursor: pointer;
  width: 146px;
  border-radius: 2px;
  font-size: 16px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3699ff;
  img {
    width: 20px;
    height: 20px;
    margin-left: 12px;
  }
}

@media screen and (max-width: 1400px) {
  .btn {
    margin-top: 0;
  }
}
</style>
